<router-outlet>
  <tour-step-template>
    <ng-template let-step="step">
      <mat-card (click)="$event.stopPropagation()" data-testid="tour-step-card">
        <mat-card-title>
          <div class="title-text" data-testid="tour-step-title">{{step?.title}}</div>
        </mat-card-title>
  
        <mat-card-content [innerHTML]="step?.content" data-testid="tour-step-content"></mat-card-content>
  
        <mat-card-actions>
          <button
            *ngIf="tourService.hasPrev(step)"
            mat-button
            class="prev"
            (click)="tourService.prev()"
            data-testid="tour-step-prev-button"
          >{{step?.prevBtnTitle}}</button>
          <button
            *ngIf="tourService.hasNext(step)"
            mat-button
            class="next"
            (click)="tourService.next()"
            data-testid="tour-step-next-button"
          >{{step?.nextBtnTitle}}</button>
          <button
            *ngIf="!tourService.hasNext(step)"
            mat-button
            (click)="tourService.end()"
            data-testid="tour-step-end-button"
          >{{step?.endBtnTitle}}</button>
  
          <div
            *ngIf="tourService.lastStep !== step.stepId"
            class="tour-end"
            (click)="tourService.skipTour()"
            data-testid="tour-step-skip-button"
          >Skip helper</div>
        </mat-card-actions>
      </mat-card>
    </ng-template>
  </tour-step-template>
</router-outlet>

